document.addEventListener('DOMContentLoaded', _ => {
    const courseFinder = document.querySelector('#course_finder');
    if (courseFinder) {
        const csrfToken = document.querySelector('head meta[name="csrf-token"]').getAttribute('content');
        const searchFields = courseFinder.querySelectorAll('select');
        const searchResults = courseFinder.querySelector('[course-results]');
        const resultTemplate = courseFinder.querySelector('template#course_template');
        function updateCourses(data) {
            searchResults.innerHTML = '';
            if (data.length < 1) {
                const notFoundContainer = document.createElement('div');
                notFoundContainer.classList.add('col-12');
                const notFound = document.createElement('p');
                notFound.textContent = 'No courses were found, please change your search and try again.';
                notFound.classList.add('text-center');
                notFoundContainer.appendChild(notFound);
                searchResults.appendChild(notFoundContainer);
            } else {
                let resultRow = undefined;
                data.forEach(course => {
                    resultRow = resultTemplate.content.cloneNode(true);
                    resultRow.querySelector('a').href = '/' + course.slug;
                    resultRow.querySelector('p.course-result-link').textContent = course.name;
                    resultRow.querySelector('p.course-result-description').textContent = course.description;
                    searchResults.appendChild(resultRow);
                })
            }
        }
        function searchCourses() {
            let data = new URLSearchParams();
            data.append('_token', csrfToken);
            let hasData = false;
            searchFields.forEach(e => {
                if (e.value > 0) {
                    hasData = true;
                }
                data.append(e.name, e.value);
            });
            if (hasData) {
                searchResults.innerHTML = '';
                courseFinder.style.setProperty('pointer-events', 'none');
                courseFinder.style.setProperty('opacity', '0.5');
                fetch('/course-search', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: data
                })
                    .then(response => response.json())
                    .then(result => {
                        updateCourses(result);
                        courseFinder.style.removeProperty('pointer-events');
                        courseFinder.style.removeProperty('opacity');
                    });
            } else {
                searchResults.innerHTML = '';
                const searchPromptContainer = document.createElement('div');
                searchPromptContainer.classList.add('col-12');
                const searchPrompt = document.createElement('p');
                searchPrompt.classList.add('text-center');
                searchPrompt.textContent = 'Use the search options above to find a course that suits you.';
                searchPromptContainer.appendChild(searchPrompt);
                searchResults.appendChild(searchPromptContainer);
            }
        }
        searchFields.forEach(e => {
            e.addEventListener('change', searchCourses);
        });
    }

    const unitFinder = document.querySelector('#unit_finder');
    if (unitFinder) {
        const csrfToken = document.querySelector('head meta[name="csrf-token"]').getAttribute('content');
        const searchFields = unitFinder.querySelectorAll('select');
        const searchResults = unitFinder.querySelector('[unit-results]');
        const resultTemplate = unitFinder.querySelector('template#unit_template');
        function updateUnits(data) {
            searchResults.innerHTML = '';
            if (data.length < 1) {
                const notFoundContainer = document.createElement('div');
                notFoundContainer.classList.add('col-12');
                const notFound = document.createElement('p');
                notFound.textContent = 'No units were found, please change your search and try again.';
                notFound.classList.add('text-center');
                notFoundContainer.appendChild(notFound);
                searchResults.appendChild(notFoundContainer);
            } else {
                let resultRow = undefined;
                data.forEach(unit => {
                    resultRow = resultTemplate.content.cloneNode(true);
                    resultRow.querySelector('a').href = '/' + unit.slug;
                    resultRow.querySelector('p.unit-result-link').textContent = unit.name;
                    resultRow.querySelector('p.unit-result-description').textContent = unit.description;
                    searchResults.appendChild(resultRow);
                })
            }
        }
        function searchUnits() {
            let data = new URLSearchParams();
            data.append('_token', csrfToken);
            let hasData = false;
            searchFields.forEach(e => {
                if (e.value > 0) {
                    hasData = true;
                }
                data.append(e.name, e.value);
            });
            if (hasData) {
                searchResults.innerHTML = '';
                unitFinder.style.setProperty('pointer-events', 'none');
                unitFinder.style.setProperty('opacity', '0.5');
                fetch('/unit-search', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: data
                })
                    .then(response => response.json())
                    .then(result => {
                        updateUnits(result);
                        unitFinder.style.removeProperty('pointer-events');
                        unitFinder.style.removeProperty('opacity');
                    });
            } else {
                searchResults.innerHTML = '';
                const searchPromptContainer = document.createElement('div');
                searchPromptContainer.classList.add('col-12');
                const searchPrompt = document.createElement('p');
                searchPrompt.classList.add('text-center');
                searchPrompt.textContent = 'Use the search options above to find a unit.';
                searchPromptContainer.appendChild(searchPrompt);
                searchResults.appendChild(searchPromptContainer);
            }
        }
        searchFields.forEach(e => {
            e.addEventListener('change', searchUnits);
        });
    }
})